import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfe35116"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StoryForm" }
const _hoisted_2 = { class: "StoryForm__header" }
const _hoisted_3 = { class: "text-xl" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_5 = { class: "StoryForm__container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg text-gray-500" }, "Основное", -1))
const _hoisted_7 = { class: "w-full flex items-start mt-3" }
const _hoisted_8 = { class: "w-1/2 flex items-center justify-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "flex items-center justify-center w-full h-60 bg-gray-100 border"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none text-gray-400 text-sm" }, " Здесь будет ваша обложка ", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "w-1/2 pl-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_15 = { class: "StoryForm__container" }
const _hoisted_16 = { class: "text-lg text-gray-500" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "flex justify-center items-center mt-3 text-sm select-none"
}
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = {
  key: 0,
  class: "mt-3 flex items-center"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_loader = _resolveComponent("loader")!
  const _component_story_form_slide = _resolveComponent("story-form-slide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.formTitle), 1),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.state.basic.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "w-60 h-60",
                src: _ctx.state.basic.image
              }, null, 8, _hoisted_9))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_the_input, {
            class: "w-full",
            placeholder: "Название истории",
            value: _ctx.state.basic.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.basic.name) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_file_reader, {
            class: "w-full mt-3",
            accept: "image/*",
            value: _ctx.state.basic.images,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.basic.images) = $event)),
            placeholder: "Выберите обложку",
            onChange: _ctx.setCover
          }, null, 8, ["value", "onChange"]),
          _createVNode(_component_the_select, {
            placeholder: "Кому отображать",
            options: _ctx.VISIBILITY_TYPES,
            value: _ctx.state.basic.visibilityType,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.basic.visibilityType) = $event)),
            "select-by": "id",
            class: "mt-3",
            searchable: false
          }, null, 8, ["options", "value"]),
          _createVNode(_component_the_button, {
            class: "primary text small mt-3 w-full",
            onClick: _ctx.saveHandler,
            loading: _ctx.state.basic.is_saving
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _createTextVNode(" Сохранить ")
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("h2", _hoisted_16, [
        _createTextVNode(" Слайды "),
        (_ctx.state.basic.is_saved)
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "(" + _toDisplayString(_ctx.state.slides.length) + ")", 1))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.state.basic.is_saved)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_ctx.state.basic.is_saving || _ctx.state.is_slides_loading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Слайды можно будет добавить после того как вы сохраните основную информацию ")
                ], 64))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.slides, (slide, i) => {
          return (_openBlock(), _createBlock(_component_story_form_slide, {
            class: "mt-3",
            key: slide.id,
            slide: slide,
            index: i,
            "story-id": _ctx.state.basic.id,
            onSave: _ctx.updateSlide,
            onDelete: _ctx.deleteSlide
          }, null, 8, ["slide", "index", "story-id", "onSave", "onDelete"]))
        }), 128)),
        (_ctx.state.basic.is_saved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_file_reader, {
                class: "w-4/5",
                placeholder: "Выберите изображение слайда",
                accept: "image/*",
                value: _ctx.slide_form.images,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.slide_form.images) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_button, {
                class: "ml-2 primary small text w-1/5 h-full",
                disabled: _ctx.slide_form.images.length === 0,
                loading: _ctx.slide_form.is_creating,
                onClick: _ctx.createSlide
              }, {
                default: _withCtx(() => [
                  _hoisted_21,
                  _createTextVNode(" Добавить ")
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}